export const COLUMNS = [
  {
    accessor: "promo_code",
    Header: "Promo Code",
  }, 
  {
    accessor: "title",
    Header: "Title",
  }, 
  {
    accessor: "is_active",
    Header: "Status",
    width: 100,
    Cell: (data) => {
      const d = data?.row?.original; 
      return (<>
        {d.is_active ? 
          <div className='bg-[#f6ffed] border-[1px] border-[#b7eb8f] w-[100px] rounded-sm flex items-center justify-center'>
            <span className='text-xs text-[#389e0d] p-1'>Active</span>
          </div> 
          : 
          <div className='bg-[#fff1f0] border-[1px] border-[#ffa39e] w-[100px] rounded-sm flex items-center justify-center'>
            <span className='text-xs text-[#cf1322] p-1'>Inactive</span>
          </div>
          }
      </>) 
    },
  },
];
